// all global constants goes here

// auth
export const AUTH_TOKEN_KEY = 'AUTH_TOKEN';
export const AUTH_TOKEN_TYPE = 'AUTH_TOKEN_TYPE';
export const USER_NAME = 'USER_NAME';
export const PHONE_NUMBER = 'PHONE_NUMBER';
export const RECOMMEND_TAB = 'RECOMMEND_TAB';
export const AUTO_LOGOUT_PATH = 'AUTO_LOGOUT_PATH';
export const HAS_PASSWORD = 'HAS_PASSWORD';
export const LOGIN_TYPE = 'LOGIN_TYPE';


